import React from "react";
import { observer } from "mobx-react";
import { Card, CardPanel, IconHighlight, Button, Skeleton, WidgetEmptyErrorPlaceholder } from "@ann/web-components";
import { RepairOrdersContent } from "./components";
import ScrollableCardContent from "../ScrollableCardContent";
import { useRepairOrdersSnapshot } from "../../../../hooks/useRepairOrdersSnapshot/useRepairOrdersSnapshot";

const RepairOrders = observer(() => {
  const { loading, error, isEmpty, orders, meta, refetch } = useRepairOrdersSnapshot();

  if (loading) {
    return <Skeleton height="429px" width="100%" />;
  }


  if (error) {
    return (
      <Card size='large'>
        <CardPanel isExpandable={false} openDefault={true}>
          <CardPanel.Content>
            <WidgetEmptyErrorPlaceholder
              buttonText="Retry"
              icon="error"
              message="We couldn't load your Repair Orders. Please try again."
              onClick={refetch}
              showButton
              title="Something went wrong"
            />
          </CardPanel.Content>
        </CardPanel>
      </Card>
    );
  }

  if (isEmpty || !orders.length) {
    return (
      <Card size='large'>
        <CardPanel isExpandable={false} openDefault={true}>
          <CardPanel.Content>
            <WidgetEmptyErrorPlaceholder
              icon="build"
              message="You'll see service details here when work is created."
              showButton={false}
              title="No Repair Orders yet"
            />
          </CardPanel.Content>
        </CardPanel>
      </Card>
    );
  }

  const totalItems = meta?.total_items ?? orders.length;

  return (
    <Card size="large">
      <CardPanel isExpandable={false}>
        <CardPanel.Header title="Repair Orders" subtitle={`(${totalItems})`}>
          <CardPanel.Header.LeftSlot>
            <IconHighlight
              icon="build"
              bgColor="primary"
              iconColor="primary"
              size="medium"
            />
          </CardPanel.Header.LeftSlot>
        </CardPanel.Header>
        <CardPanel.Content>
          <ScrollableCardContent>
            <RepairOrdersContent orders={orders} />
          </ScrollableCardContent>
        </CardPanel.Content>
        <CardPanel.Actions>
          <Button size="medium" type="secondary" label="View all" />
        </CardPanel.Actions>
      </CardPanel>
    </Card>
  );
});

export default RepairOrders;
